import { ThemeVariants } from '@stripcash/ui-kit/hoc/Theme';
import sysend from 'sysend';

import { CHECK_THEME_SYSEND_EVENT, LS_THEME_ID } from 'common/constants/common';
import { LocalStorage } from 'common/helpers/Storage';

const onThemeChange = (newTheme: ThemeVariants) => {
  if (newTheme === ThemeVariants.Dark) {
    document.documentElement.classList.add(ThemeVariants.Dark);
    LocalStorage.set(LS_THEME_ID, ThemeVariants.Dark);
  } else {
    document.documentElement.classList.remove(ThemeVariants.Dark);
    LocalStorage.set(LS_THEME_ID, ThemeVariants.Light);
  }

  sysend.broadcast(CHECK_THEME_SYSEND_EVENT, { themeId: newTheme });
};

export default onThemeChange;
